<template>
	<div class="container-list"><reportcompany :c_id="1" :is_tab="true" /></div>
</template>

<script>
import reportcompany from '@/components/reportcomp';
export default {
	components: { reportcompany },

	data() {
		return {
			list: [],
			params: { page: 1, bg_uuid: this.$route.query.id },
			total: 0,
			id: this.$route.query.id,
			showDia: false,
			searchForm: this.$getForm('userSearch'),
			editData: {},
			remoteFuncs: {},
			cpname: ''
		};
	}
};
</script>

<style scoped>
.container-list {
	margin: 20px;
	padding: 0px;
}
</style>
